import { css } from "lit";

export const styles = css`
  :host {
    display: inline-block;
  }

  .avatar-container {
    position: relative;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease;
    background: #e5e7eb;
  }

  .avatar-container:hover,
  .avatar-container.dragging {
    transform: scale(1.05);

    .upload-overlay {
      opacity: 1;
    }
  }

  .avatar-container:focus-visible {
    outline: 2px solid var(--color-primary, #007bff);
    outline-offset: 2px;
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .fallback-avatar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-overlay {
    position: absolute;
    inset: 0 0 0 0;
    background: rgb(0 0 0 / 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;
    border-radius: 50%;
  }

  .upload-icon {
    color: white;
    font-size: 20px;
  }

  .file-input {
    display: none;
  }

  /* Modal content styling */
  .modal-content {
    display: flex;
    flex-direction: column;

    min-height: 400px;
  }

  cropper-canvas {
    width: 100%;
    height: 400px;
  }
  cropper-shade {
    border-radius: 50%;
  }

  .uploading .upload-overlay {
    opacity: 1;
    background: rgb(0 0 0 / 0.7);
  }

  .spinner {
    color: white;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
